// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"5352c17f","676":"ac56f4a2","707":"59d7897c"}[chunkId] + ".chunk.js";
};